/**
 * Coups de pouce — Attendu 641 « Calculer le périmètre d'un disque ».
 *
 * Une entrée par `generator_key` (cf. gen_641.js). Les 6 formats testent le
 * MÊME geste (choisir la formule → calculer → arrondir) : une seule fiche
 * partagée, référencée par les 6 clés — cohérence garantie. Donner les
 * formules est légitime ici (pas un « pur rappel » : le travail résiduel est
 * le calcul lui-même). Exemple HORS pools : R = 100 (tous les rayons ≤ 50).
 * Convention du gen : touche π de la calculatrice (revue 2026-07-31).
 */

const FICHE_CALCUL = {
    pages: [
        {
            titre: 'La bonne formule',
            lignes: [
                'Si on donne le **rayon** : P = **2 × π × R**. Si on donne le **diamètre** : P = **π × D**.',
                'Tape le calcul avec la **touche π**, puis arrondis au **dixième**.',
            ],
        },
        {
            titre: 'Un exemple',
            lignes: [
                'Rayon R = **100** m : P = 2 × π × 100 ≈ 628,3185…',
                'Arrondi au dixième : **628,3** m.',
            ],
        },
    ],
};

const CP_641 = {
    calcul_perimetre_qcm_unique: FICHE_CALCUL,
    calcul_perimetre_texte: FICHE_CALCUL,
    calcul_perimetre_contexte_texte: FICHE_CALCUL,
    calcul_perimetre_relier: FICHE_CALCUL,
    calcul_perimetre_tableau_vf: FICHE_CALCUL,
    calcul_perimetre_texte_trou_saisie: FICHE_CALCUL,
};

export default CP_641;
